import { render } from "./app-header-message.vue?vue&type=template&id=48de5f7e"
import script from "./app-header-message.vue?vue&type=script&lang=js"
export * from "./app-header-message.vue?vue&type=script&lang=js"

import "./app-header-message.vue?vue&type=style&index=0&id=48de5f7e&lang=less"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__